(function () {
    'use strict';

    angular
        .module('app')
        .controller('AboutController', AboutController);

    AboutController.$inject = ['$rootScope', '$stateParams', 'cache', '$translate', 'dialog'];

    function AboutController($rootScope, $stateParams, cache, $translate, dialog) {
        var vm = this;
        vm.$onInit = init;
        vm.changeLanguage = changeLanguage;

        function init() {
            $rootScope.header_inverted = true;
            $rootScope.on_dashboard = false;
            $rootScope.separate_page = false;
            $rootScope.dark_text_header = false;
            cache.reset('scrollY');

            window.document.title = $stateParams.language == 'da' ? "Om Be My Concert" : "About Be My Concert";
        }

        function changeLanguage(lang){
            $translate.use(lang); 
        }
    }
})();